/** 维护全局公告数量 */
import type { GetNoticeShowByIdResponse } from '@/api/notice-config/model.d'
import { getNoticeUnReadCount } from '@/api/notice-config'
import { NOTICE_READ_STATUS } from './constants'
const count = ref(0)
/** 初始化 */
let init: Nullable<() => void> = async () => {
  await refresh()
  init = null // 销毁初始化函数
}

/**
 * 用户阅读公告
 * 若该公告未读，则触发未读数-1
 */
function readNotice(notice: GetNoticeShowByIdResponse) {
  if (count.value === 0) return // 不能小于0
  if (notice.isRead === NOTICE_READ_STATUS.NO) count.value--
}
/** 更新未读数量 */
async function refresh() {
  count.value = await getNoticeUnReadCount()
}

export function useNotification() {
  init && init()
  return {
    count,
    readNotice,
    refresh
  }
}
export default useNotification
